import React, { useEffect } from "react";
import cardsImage from "../../assets/img/cards.svg";
import storefront from "../../services/storefront.service";
import Translation from "../../services/translation.service";

const SelectionCard = ({ key, card, selectedCard, handleSelectedCard }) => {
  const language = Translation.getCurrentLanguage();

  useEffect(() => {
    setTimeout(() => {
      storefront.tabHorizontalScroll("eligibility_", selectedCard);
    }, 0);
  }, [language]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      id={`eligibility_${card?.Id}`}
      key={`elegibility-selection-${key}`}
      className={`selection-card ${card?.Id === selectedCard ? "active" : ""}`}
      onClick={() => handleSelectedCard(card?.Id)}
    >
      <img
        src={
          storefront.getPoImage(
            "stf_eligibility_tab",
            `${card?.Id.toLowerCase()}-${
              card?.Id === selectedCard ? "active" : "inactive"
            }`
          ) || cardsImage
        }
        alt="img"
      />
      <p className={card?.Id === selectedCard ? "active" : ""}>{card?.Type}</p>
    </div>
  );
};

export default SelectionCard;
